export default "__VITE_ASSET__BkIXXW6B__"